import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import ImageGrid from './widgets/ImageGrid'
import { BlockWrapper, CollapseText, Container, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


AlbumGalleryCard.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    text: PropTypes.string,
    images: PropTypes.arrayOf(ImageType),
  }),
}

export default function AlbumGalleryCard({
  data = {},
}) {
  const html = data.text || ''

  return (
    <BlockWrapper>
      <Container size="xl">
        <div className={classNames.descriptionRow}>
          <div>
            <Typography variant="h2" tag={data.heading_hx} className={classNames.desktopHeading}>{data.heading}</Typography>
            <div
              className={`${classNames.desktopText} ${classNames.textHtml}`}
              dangerouslySetInnerHTML={{ __html: html }}
            />
            <CollapseText isCollapsedDefault initialHeight={120} className={classNames.mobileText}>
              <div
                className={classNames.textHtml}
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </CollapseText>
          </div>
          {!isEmpty(data.images) && (
            <div>
              <ImageGrid images={data.images} />
            </div>
          )}
        </div>
      </Container>
    </BlockWrapper>
  )
}
